import { ModalWindow, Collection, Table, TextInput, NumberInput, Button } from "@tblabs/truffle";
import { ProductSelector } from "../Components/ProductSelector";
import { DateTimeEditInput } from "../Components/Utils/DateSlider";
import { Icons } from "../Components/Utils/Icons";
import { DefaultButton, DefaultIconButton } from "../Components/Utils/XPrimaryButton";
import { BasketItem } from "../Models/Basket/BasketItem";
import { RentBasketItem } from "../Models/Basket/RentBasketItem";
import { ShopContent } from "../Shop/ShopContent";
import { SaleBasketItem } from "../Models/Basket/SaleBasketItem";
import { PrimaryButton } from "../Components/Utils/PrimaryButton";
import { TableViewer } from "./Admin/TableViewer";
import { FormRow } from "../Components/FormRow";
import { FormPrinter } from "../Components/FormPrinter";


export class AddRentItemWindow extends ModalWindow
{
    constructor(shop: ShopContent, basketItems: Collection<BasketItem>)
    {
        super("Dodaj wynajem");

        const item = new RentBasketItem({});

        this.AddContent(
            new FormPrinter(
                new FormRow("Produkt", new ProductSelector(shop.Products.Items, item)),
                new FormRow("Początek", new DateTimeEditInput(item.From)),
                new FormRow("Koniec", new DateTimeEditInput(item.To)),
                new FormRow("Numer seryjny", new TextInput(item.ProductSerialNumber)),
                new FormRow("Dane dostępowe", new TextInput(item.AccessData)),
                new FormRow("Ilość", new NumberInput(item.Quantity)),
                new FormRow("Cena", new NumberInput(item.TotalPrice)),
                new FormRow("Kaucja", new NumberInput(item.Deposit)),
            )
        );
        this.AddToFooter(
            new PrimaryButton("Dodaj",  () =>
            {
                basketItems.Add(item);
                this.CloseWindow();
            }),
            new DefaultButton("Anuluj", () => this.CloseWindow()).MarginLeft(8)
        );

        this.OpenWindow();
    }
}


export class AddSaleItemWindow extends ModalWindow
{
    constructor(shop: ShopContent, basketItems: Collection<BasketItem>)
    {
        super("Dodaj sprzedaż");

        const item = new SaleBasketItem({});

        this.AddContent(
            new FormPrinter(
                new FormRow("Produkt", new ProductSelector(shop.Products.Items, item)),
                new FormRow("Numer seryjny", new TextInput(item.ProductSerialNumber)),
                new FormRow("Dane dostępowe", new TextInput(item.AccessData)),
                new FormRow("Ilość", new NumberInput(item.Quantity)),
                new FormRow("Cena", new NumberInput(item.TotalPrice)),
            )
        );
        this.AddToFooter(
            new PrimaryButton("Dodaj", () =>
            {
                basketItems.Add(item);
                this.CloseWindow();
            }),
            new DefaultButton("Anuluj", () => this.CloseWindow()).MarginLeft(8)
        );

        this.OpenWindow();
    }
}
